module.exports = __webpack_public_path__ + "static/media/bytt-no-21.4c9f9301.mp3";